import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { format } from 'date-fns'

import { getUserFullName } from '@utils/users'

import { AuthorNameTextSx } from './styles'

export interface IAuthorAndDateInfoProps {
  author: { firstName?: string; lastName?: string } | undefined
  publishedDate: Date | undefined
}

const AuthorAndDateInfo = ({
  author,
  publishedDate,
}: IAuthorAndDateInfoProps) => {
  const { t } = useTranslation()
  const adminName = getUserFullName(author ?? {})
  const formattedPublishedDate = format(
    publishedDate ?? new Date(),
    'MMM dd, yyyy'
  )

  return (
    <>
      {t('By')}
      &nbsp;
      <Box component="span" sx={AuthorNameTextSx}>
        {adminName ?? t('Unknown')}
      </Box>
      &nbsp;
      {`- ${formattedPublishedDate}`}
    </>
  )
}

export { AuthorAndDateInfo }
